import { registerCapability } from '../../platform/capability-registry';
import { ImageVmBlock } from './ImageVmBlock';
import { IMAGE_VM_ACTION_KEY_LIST, IMAGE_VM_FIELD_KEY_LIST } from './fieldKeys';
import { resolveImageVmPaths } from './resolvePaths';
import type { ImageVmBlockOptions } from './types';

registerCapability<ImageVmBlockOptions>({
  key: 'image-vm',
  fields: [...IMAGE_VM_FIELD_KEY_LIST],
  actions: [...IMAGE_VM_ACTION_KEY_LIST],
  component: ImageVmBlock,
  defaultPaths: (prefix) => resolveImageVmPaths(prefix),
  resolvePaths: (prefix, options) => resolveImageVmPaths(prefix, options),
});
